export function articleProgress() {
    window.addEventListener("scroll", function () {
        let scrollTop = document.documentElement.scrollTop;
        let scrollHeight = document.querySelector(".single-post-page").clientHeight - document.documentElement.clientHeight;
        let scrollPercentage = (scrollTop / scrollHeight) * 100;

        document.getElementById("progress-bar").style.width = scrollPercentage + "%";
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/articleProgress.js